/**
 * Yotpo Heading Fix
 *
 * Yotpo's Visual UGC gallery lightbox renders each tagged product name as an
 * <h2 class="yotpo-lightbox-product-name">. These compete with the page's primary
 * content H2 headings and pollute the document outline. This downgrades them to
 * <h3> while preserving classes, attributes, and inner content.
 *
 * The markup is injected/re-rendered by Yotpo's external widget.js, so we process
 * any existing nodes on load and watch the DOM to re-apply as Yotpo updates it.
 */

(function () {
  'use strict';

  var SELECTOR = 'h2.yotpo-lightbox-product-name';

  function downgrade(h2) {
    if (!h2 || h2.tagName !== 'H2' || !h2.parentNode) return;

    var h3 = document.createElement('h3');
    for (var i = 0; i < h2.attributes.length; i++) {
      var attr = h2.attributes[i];
      h3.setAttribute(attr.name, attr.value);
    }
    h3.innerHTML = h2.innerHTML;
    h2.parentNode.replaceChild(h3, h2);
  }

  function processAll(root) {
    if (root && root.nodeType === 1 && root.matches && root.matches(SELECTOR)) {
      downgrade(root);
      return;
    }
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) downgrade(nodes[i]);
  }

  function init() {
    processAll(document);

    var observer = new MutationObserver(function (mutations) {
      for (var m = 0; m < mutations.length; m++) {
        var added = mutations[m].addedNodes;
        for (var n = 0; n < added.length; n++) {
          var node = added[n];
          if (node.nodeType !== 1) continue;
          processAll(node);
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
